module.exports = __webpack_public_path__ + "static/media/chartsChart.8b09fb01.png";